import { Tooltip } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import MarkdownRenderer from '../markdown-renderer/MarkdownRenderer';

const MUIToolTip: FC<{ title: string; children: ReactNode; showTootip?: boolean; id?: string }> = ({
	title,
	children,
	showTootip = true,
	id = 'tooltip',
}) => {
	if (showTootip) {
		return (
			<Tooltip title={<MarkdownRenderer markdown={title} />} arrow placement='top' id={id}>
				<span style={{ maxWidth: 'fit-content' }}>{children}</span>
			</Tooltip>
		);
	} else {
		return <>{children}</>;
	}
};

export default MUIToolTip;
